import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'ecm-visitor-header',
    templateUrl: 'visitor-header.html',
    styleUrls: ['visitor-header.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VisitorHeaderComponent {}
